import { render, staticRenderFns } from "./ServiceFormDetail.vue?vue&type=template&id=63320c93&"
import script from "./ServiceFormDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFormDetail.vue?vue&type=style&index=0&id=63320c93&prod&lang=css&"
import style1 from "./ServiceFormDetail.vue?vue&type=style&index=1&id=63320c93&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports